import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["animationData", "animationLink", "className", "interactivity", "lottieRef", "renderParams", "style"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { axiosBeelineRequest } from '@beef/utils';
import { useForkRef } from "./hooks/useForkRef";
import { useLottie } from "./hooks/useLottie";
import { useLottieInteractivity } from "./hooks/useLottieInteractivity";
export var LottiePlayer = /*#__PURE__*/forwardRef(function (props, ref) {
  var _interactivity$action, _interactivity$mode;
  var animationDataProp = props.animationData,
    animationLink = props.animationLink,
    className = props.className,
    interactivity = props.interactivity,
    lottieRef = props.lottieRef,
    renderParams = props.renderParams,
    style = props.style,
    lottieProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(animationDataProp),
    _useState2 = _slicedToArray(_useState, 2),
    animationData = _useState2[0],
    setAnimationData = _useState2[1];
  var wrapperRef = useRef(null);
  var loadAnimation = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
      var data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return axiosBeelineRequest({
              headers: {
                'Content-Type': 'application/json'
              },
              withCredentials: false,
              method: 'GET',
              url: path
            });
          case 3:
            data = _context.sent;
            setAnimationData(data);
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            setAnimationData(undefined);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function loadAnimation(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (animationLink) {
      // eslint-disable-next-line no-void
      void loadAnimation(animationLink);
    }
  }, [animationLink]);
  var animationParams = useLottie(wrapperRef, _objectSpread({
    animationData: animationData,
    height: style === null || style === void 0 ? void 0 : style.height,
    width: style === null || style === void 0 ? void 0 : style.width
  }, lottieProps));
  useEffect(function () {
    if (lottieRef) {
      lottieRef.current = animationParams;
    }
  }, [lottieRef === null || lottieRef === void 0 ? void 0 : lottieRef.current]);
  useLottieInteractivity({
    actions: (_interactivity$action = interactivity === null || interactivity === void 0 ? void 0 : interactivity.actions) !== null && _interactivity$action !== void 0 ? _interactivity$action : [],
    lottieObj: animationParams,
    mode: (_interactivity$mode = interactivity === null || interactivity === void 0 ? void 0 : interactivity.mode) !== null && _interactivity$mode !== void 0 ? _interactivity$mode : 'scroll',
    wrapperRef: interactivity === null || interactivity === void 0 ? void 0 : interactivity.wrapperRef
  });
  var nodeRef = useForkRef([ref, wrapperRef]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: className,
    ref: nodeRef,
    style: style
  }, renderParams, {
    "data-t-id": "components-LottiePlayer"
  }));
});